import { useState } from 'react';
// import { useDispatch } from 'react-redux';
import BRAND_LOGO from '../../images/Monitoring_Ronin_Longer.gif';
// import Footer from '../Footer';
import SideBarSmallScreen from '../SideBarSmallScreen';
import { siteSetupInstructionLink, nxWitnessPdfGuide, contactNum, contactNumNoSpace, contactEmail, application, webURL } from '../../config';
// import { businessTokenMapping } from '../../redux/actions/businessTokenMappingActions';
// import { fetchUser } from '../../redux/actions/fetchUser';
import { FaDownload, FaStarOfLife, FaYoutube } from 'react-icons/fa';

// Import generic components
import Footer from '../../generic_components/Footer/Footer';
import Button from '../../generic_components/Button/Button';

// check if the screen is small
const isSmallScreen = window.innerWidth <= 768;  

const OnboardingSite = () => {
    // let user = window.localStorage.getItem('email');
    const [showVideo, setShowVideo] = useState(false);
    
    const handleVideo = () => {
        setShowVideo(prev => !prev);
    }

    // useEffect(() => {
    // if (user)
    //     dispatch(businessTokenMapping({user: user}));
    // }, [user, dispatch]);

    // useEffect(() => {
    //     dispatch(fetchUser(user));
    // }, [user, dispatch]);

    return (
        <div className="onboarding-container">
           <div className="onboarding-content">
             <div className="logo-container-health">
                <img src={BRAND_LOGO} alt='SAMURAI' className='home-image-health'></img>
            </div>
            <h2 className="welcome-message">👋 Welcome to {application}!</h2>
            <h4 className="business-message">It seems like you do not have any sites set up with us yet.</h4>
            <p style={{color: 'rgb(244, 149, 35)'}}>Need help setting up your first site?</p>

            <div className='guide-container'>
                <div className='guide-buttons'>
                    <Button 
                        size='large'
                        className="home-btn-style-onboard" 
                        onClick={() => window.location.href = "/#installer/health"}
                    >
                        <FaStarOfLife style={{ marginRight: '0.3em' }} />
                        Interactive Install Guide
                    </Button>

                    <Button
                        size='large'
                        className="home-btn-style-onboard" 
                        onClick={() => window.open(nxWitnessPdfGuide, '_blank')}
                    >
                        <FaDownload style={{ marginRight: '0.3em' }} />
                        Download Full Guide
                    </Button>
                   
                    <Button
                        size='large' 
                        className='home-btn-style-onboard' 
                        onClick={handleVideo}
                    >
                        <FaYoutube style={{ marginRight: '0.3em' }}/> 
                        Watch Video Tutorial
                    </Button>
                </div>

                {showVideo && (
                    <div style={{ marginTop: '1rem' }}>
                    <iframe
                        width={isSmallScreen?"100%":"40%"}
                        height="315"
                        src={siteSetupInstructionLink} // Replace with instruction video later
                        title="How to Set Up a Site"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                    </div>
                )}

                <div className='contact-container'>
                    <p>Alternatively, you can contact us: </p>
                    <ul className='contact-details'>
                        <li><i className="fa fa-phone"></i><a href={`tel:${contactNumNoSpace}`} className='contact-detail'> {contactNum}</a></li>
                        <li><i className="fa-solid fa-envelope"></i><a href={`mailto:${contactEmail}`} className='contact-detail'> {contactEmail}</a></li>
                    </ul>
                </div>               

            </div>

            {isSmallScreen && <SideBarSmallScreen/>}

            <div className='onboarding-footer'>
                <Footer url={webURL}/>
            </div>
           </div>
        </div>
    );
};

export default OnboardingSite;